import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider as StoreProvider } from 'react-redux'
import { StyleSheetManager } from 'styled-components'
import posthog from 'posthog-js'
import AuthProvider from './modules/Auth/providers/AuthSupabaseProvider/AuthProvider.container'
import { initializeLogger } from './core/debuggers'
import AppThemeProvider from './components/Theme/AppThemeProvider'
import App from './App'
import { store } from './config/store/store'

const posthogKey = process.env.REACT_APP_POSTHOG_KEY
const posthogHost = process.env.REACT_APP_POSTHOG_HOST

if (posthogKey && posthogHost) {
  posthog.init(posthogKey, { api_host: posthogHost, defaults: '2026-05-30', capture_exceptions: true })
} else if (process.env.NODE_ENV !== 'production') {
  if (!posthogKey) {
    console.error('REACT_APP_POSTHOG_KEY variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once REACT_APP_POSTHOG_KEY is configured')
  }
  if (!posthogHost) {
    console.error('REACT_APP_POSTHOG_HOST variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once REACT_APP_POSTHOG_HOST is configured')
  }
}

const root = createRoot(document.getElementById('root'));

initializeLogger({ environment: 'dev' })

root.render(
  <StyleSheetManager disableVendorPrefixes>
    <StoreProvider store={store}>
      <AuthProvider>
        <AppThemeProvider>
          <App />
        </AppThemeProvider>
      </AuthProvider>
    </StoreProvider>
  </StyleSheetManager>
)
